module.exports = __webpack_public_path__ + "public-ui/img/chevron-right.ecf6d157.svg";